import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WelcomeSection } from '../components/WelcomeSection';
import { FocusSection } from '../components/FocusSection';
import { TrustSection } from '../components/TrustSection';
import { ServicesSection } from '../components/ServicesSection';
import { OpeningHoursSection } from '../components/OpeningHoursSection';
import { SmileViewSection } from '../components/SmileViewSection';
import { TeamSection } from '../components/TeamSection';
import { BlogPreview } from '../components/BlogPreview';
import { AppointmentCTA } from '../components/AppointmentCTA';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-weiss flex flex-col" data-id="element-226">
      <Navigation data-id="element-227" />
      <main className="flex-grow" data-id="element-228">
        <HeroSection data-id="element-229" />
        <WelcomeSection data-id="element-230" />
        <FocusSection data-id="element-231" />
        <TrustSection data-id="element-232" />
        <ServicesSection data-id="element-233" />
        <OpeningHoursSection data-id="element-234" />
        <SmileViewSection data-id="element-235" />
        <TeamSection data-id="element-236" />
        <BlogPreview data-id="element-237" />
        <AppointmentCTA data-id="element-238" />
      </main>
      <Footer data-id="element-239" />
    </div>;
}